import { useQuery, UseQueryResult } from '@tanstack/react-query'
import {
  HistoryDownloadLogItem,
  HistoryDownloadLogReqParams,
  HistoryUserLogItem,
  HistoryUserLogReqParams,
  InterfaceHistoryItem,
  InterfaceHistoryParams,
} from '@/services/history/history.types'
import { getHistoryDownloadLog, getHistoryUserLog, getInterfaceHistory } from '@/services/history/apis'

export const PAGE_SIZE_ON_HISTORY = 10000

const GET_HISTORY_USER_LOG = ['HS01', 'GET_HISTORY_USER_LOG']
const GET_HISTORY_DOWNLOAD_LOG = ['HS03', 'GET_HISTORY_DOWNLOAD_LOG']
const GET_INTERFACE_HISTORY = ['RP06', 'GET_INTERFACE_HISTORY']

export const useGetHistoryUserLog = (params: HistoryUserLogReqParams): UseQueryResult<{ list: HistoryUserLogItem[] }, Error> =>
  useQuery({
    queryKey: GET_HISTORY_USER_LOG,
    queryFn: () => getHistoryUserLog(params),
    select: ({ data }) => ({ list: data.items }),
    enabled: false,
  })

export const useGetHistoryDownloadLog = (params: HistoryDownloadLogReqParams): UseQueryResult<{ list: HistoryDownloadLogItem[] }, Error> =>
  useQuery({
    queryKey: GET_HISTORY_DOWNLOAD_LOG,
    queryFn: () => getHistoryDownloadLog(params),
    select: ({ data }) => ({ list: data.items }),
    enabled: false,
  })

export const useGetInterfaceHistory = (params: InterfaceHistoryParams): UseQueryResult<{ list: InterfaceHistoryItem[] }, Error> =>
  useQuery({
    queryKey: GET_INTERFACE_HISTORY,
    queryFn: () => getInterfaceHistory(params),
    select: ({ data }) => ({ list: data.items }),
    enabled: false,
  })
